// extracted by mini-css-extract-plugin
export var actionText = "_mb-4";
export var container = "_mb-0";
export var leftSection = "_mb-1";
export var rightSection = "_mb-2";
export var settingsButton = "_mb-6";
export var settingsIcon = "_mb-7";
export var shortcut = "_mb-5";
export var shortcutGroup = "_mb-3";